import React from "react"
import { Container, ImageWrapper, TextWrapper, NoteTitle, NoteText } from "./styles"
const Note = ({ image, image_note, image_background, title, notes }) => {
  return (
    <Container>
      {image && (
        <ImageWrapper background={image_background}>
          <img src={image} />
          {image_note && <span>{image_note}</span>}
        </ImageWrapper>
      )}

      <TextWrapper>
        {title && <NoteTitle>{title}</NoteTitle>}
        <NoteText>{notes}</NoteText>
      </TextWrapper>
    </Container>
  )
}

export default Note
